<template>
  <div id="">
    <div ref="boxmax" class="dr">
      <h1 class="title_enter">祥业宏发</h1>
      <input maxlength="12" @input="rule()" type="text" v-model:value="userName" placeholder="请输入账号" />
      <input maxlength="12" @input="rule()" type="password" v-model:value="password" placeholder="请输入密码" />
      <div class="remember">
        <div>
          <div
            id="jizhu"
            v-if="checked"
            @click="checked = !checked"
          >
            <i id="i_"></i>
            <span>记住密码</span>
          </div>
          <!-- background: url('../../images/lmj_hou.png'); -->
          <div
            id="jizhu"
            v-else
            @click="checked = !checked"
          >
            <i style="background: #D8D8D8"></i><span>记住密码</span>
          </div>
          <router-link
            id="tozc"
            to="/GoodsAdduser"
          >没有账号去注册</router-link>
        </div>
      </div>
      <div
        class="alsrtInfo"
        :style="{display: displayStsates}"
        ref="alertMsg"
      >
        <div class="profPrompt_test">{{aletMsg}}</div>
      </div>
      <div id="btn-dr-parend">
        <div class="btn-dr">立即登录</div>
        <div
          v-on:click="enter()"
          ref="coverage"
          class="btn_dr_coverage"
        ></div>
      </div>
    </div>

  </div>
</template>
<script>
import API from "../../lmj_Api/api";

export default {
  name: 'GoodsEnter',
  data () {
    return {
      checked: false,
      userName: "",
      password: "",
      aletMsg: "", // 弹出框中的提示语
      displayStsates: "none",
    };
  },
  mounted () {
    this.getCookie();

  },
  methods: {
    rule () {
      if (this.userName != "") {
        this.userName = this.userName.replace(/[\u4e00-\u9fa5]/g, "");
      }
      if (this.userName != "") {
        this.userName = this.userName.replace(/[\u4e00-\u9fa5]/g, "");
      }
    },
    alertDia (msg) {
      this.displayStsates = "block";
      this.aletMsg = msg;
      window.setTimeout(() => {
        this.displayStsates = "none";
      }, 1200);
    },
    stopColor () {
      setTimeout(() => {
        this.$refs.coverage.style = "background:rgba(0,0,0,0)"
      }, 200)
    },
    enter () {
      this.$refs.coverage.style = "background:rgba(0,0,0,0.1)";
      this.stopColor();
      const self = this;
      if (self.userName == "") {
        self.alertDia("没有填写账号");
        return;
      } else if (self.password == "") {
        self.alertDia("没有填写密码");
        return;
      } else if (self.userName.length > 12 || self.userName.length < 6) {
        self.alertDia("账号限制6-12位");
        return;
      } else if (self.password.length > 12 || self.password.length < 6) {
        console.log("password Length", self.password.length);
        self.alertDia("密码限制6-12位");
        return;
      }


      // 发送请求
      var _this = this;
      let val = "?account=" + this.userName + "&password=" + this.password;
      this.axios.get(API.login + val)
        .then(res => {
          console.log(res);
          var _data = res.data;
          //  登陆成功

          if (_data.code == 200) {
            // localStorage.uid = res.data.uid
            _this.$store.commit('addUserId', res.data);
            //xhx 202506041934 添加为了定时清空uid,下面新增登录开启定时任务
            // 重置无操作计时器
                _this.$store.commit('resetInactivityTimer');
            self.alertDia(_data.msg);
            if (self.checked == true) {
              //传入账号名，密码，和保存天数3个参数
              self.setCookie(self.userName, self.password, 7);
            } else {
              //清空Cookie
              self.clearCookie();
            }
            window.setTimeout(() => {
              _this.$router.push({ name: 'lmjhome' });
            }, 1300);
            // 登入失败
          } else {
            self.alertDia(_data.msg);
            // this.$store.commit('updateGoodsSelected', { id, selected: val });
          }

        })
        .catch(err => {
          console.log(err)
        })
    },
    //设置cookie
    setCookie (c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'userName') {
            this.userName = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'userPwd') {
            this.password = arr2[1];
            this.checked = true;
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
  },
  created () {
    // this.alertDia('账号限制6-12位')
  }
};
</script>
 <style lang="less" scoped>
div,
h4,
p,
input,
span {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
#chekbox_ps {
  color: #999;
  font-size: 0.26rem;
}

.dr {
  overflow: hidden;
  padding: 0 0.55rem;
  .title_enter {
    font-size: 0.36rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    text-align: center;
    margin: 0.8rem auto;
  }
  input[type='text'],
  input[type='password'] {
    display: block;
    margin: auto;
    height: 1rem;
    width: 6.2rem;
    margin-top: 0.4rem;
    border-radius: 0.25rem;
    font-size: 0.28rem;
    background: #eee;
    border: 0px;
    text-indent: 0.42rem;
  }

  // input[type="text"]{
  //   margin-top: 1.58rem!important;
  // }
  .alsrtInfo {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    .profPrompt_test {
      width: 4.2rem;
      height: 1.4rem;
      line-height: 1.4rem;
      border-radius: 0.2rem;
      color: #fff;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.6);
      opacity: 0.6;
      top: 5.98rem;
      left: 50%;
      font-size: 0.28rem;
      font-family: Gotham-Book;
      opacity: 1;
      text-align: center;
      transform: translate(-50%, -50%);
    }
  }
  input[type='text'] {
    margin-top: 0.9rem;
  }
  .remember {
    div {
      padding-left: 0.1rem;
      #tozc {
        float: right;
        color: #5fbcff;
        margin-right: 0.2rem;
        padding-top: 0;
      }
      #jizhu {
        position: relative;
        display: inline-block;
        height: 0.36rem;
        width: 3rem;
        i {
          border-radius: 6px;
          width: 0.36rem;
          height: 0.36rem;
          display: inline-block;
        }
        #i_ {
          background: url('../../images/lmj_hou.png') #5fbcff;
          background-position: 0rem 0rem;
          background-size: 0.36rem 0.36rem;
        }
        span {
          position: absolute;
          color: #999;
          left: 0.6rem;
          bottom: -0.045rem;
        }
      }
    }
    font-size: 0.28rem;
    margin-top: 0.26rem;
    position: relative;
  }
  #btn-dr-parend {
    position: relative;
    .btn-dr {
      margin-top: 1.62rem;
      text-align: center;
      width: 100%;
      height: 1.08rem;
      line-height: 1.08rem;
      background: 100% url('../../images/btn_blue.png');
      color: #fff;
      font-size: 0.32rem;
      font-weight: 500;
      border-radius: 0.5rem;
    }
    .btn_dr_coverage {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 1.08rem;
      border-radius: 0.6rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/goodsEnter/Enter.vue